// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-btn {
    text-align: right;
    position: absolute;
    top: 9px;
    right: 40px;
}

.close-btn .material-icons {
    padding: 5px;
    border: 1px #ddd solid;
    border-radius: 50px;
    position: absolute;
    background-color: #fff;
}

.modal-header h3 {
    text-align: center;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    margin: 0px;
}

.modal-header {
    position: relative;
    color: #fff;
    padding: 5px 5px;
    background-color: #003561;
}

.align-center {
    text-align: center;
}

.msg-text {
    margin-bottom: 10px !important;
    padding: 5px 10px;
    letter-spacing: 1px;
    font-weight: 100;
}

form {
    padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/protected-modal/protected-modal.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".close-btn {\n    text-align: right;\n    position: absolute;\n    top: 9px;\n    right: 40px;\n}\n\n.close-btn .material-icons {\n    padding: 5px;\n    border: 1px #ddd solid;\n    border-radius: 50px;\n    position: absolute;\n    background-color: #fff;\n}\n\n.modal-header h3 {\n    text-align: center;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n    margin: 0px;\n}\n\n.modal-header {\n    position: relative;\n    color: #fff;\n    padding: 5px 5px;\n    background-color: #003561;\n}\n\n.align-center {\n    text-align: center;\n}\n\n.msg-text {\n    margin-bottom: 10px !important;\n    padding: 5px 10px;\n    letter-spacing: 1px;\n    font-weight: 100;\n}\n\nform {\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
